/**
 * Route for `blacklist-ip-block-anonymizer-block`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { BlacklistIpBlockAnonymizerBlockPage } from "../features/blacklist-ip-block-anonymizer-block/BlacklistIpBlockAnonymizerBlockPage";

export const blacklistIpBlockAnonymizerBlockRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/blacklist-ip-block-anonymizer-block",
	component: BlacklistIpBlockAnonymizerBlockPage,
});

export default blacklistIpBlockAnonymizerBlockRoute;
